
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cosmetRegistration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"patient_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"doctor_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operation_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operation_position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"high_risk_factor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operation_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operation_place"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sign_doctor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operation_doctor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assistant1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assistant2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operation_fee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operation_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"record_person"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"create_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"update_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operation_releinfo_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"am_pm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":494}};
    doc.loc.source = {"body":"query($id: Int!){\n    cosmetRegistration(id:$id){\n        id \n        patient_id \n        doctor_id \n        operation_name \n        operation_position \n        high_risk_factor \n        operation_date \n        operation_place \n        sign_doctor \n        operation_doctor \n        assistant1 \n        assistant2 \n        operation_fee \n        operation_status \n        record_person \n        create_time \n        update_time \n        operation_releinfo_id \n        am_pm\n        note\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
